import {
  Role,
  TeamMemberRole,
  TeamMemberTransitionDisabledReason,
  TeamMemberTransitionRole,
} from '__generated__/GQL';
import assertNever from 'common/bento/lib/assertNever';
import { EditableRole } from 'features/Team/components/MemberInformationRoleForm/schema';

export const mapEditableRoleToTransitionRole = (
  editableRole: EditableRole,
): TeamMemberTransitionRole => {
  switch (editableRole) {
    case TeamMemberRole.Admin:
      return TeamMemberTransitionRole.Admin;
    case TeamMemberRole.Accountant:
      return TeamMemberTransitionRole.Accountant;
    case TeamMemberRole.Employee:
      return TeamMemberTransitionRole.Employee;
    default:
      return assertNever(editableRole);
  }
};

export const mapEditableRoleToRole = (editableRole: EditableRole): Role => {
  switch (editableRole) {
    case TeamMemberRole.Admin:
      return Role.Admin;
    case TeamMemberRole.Accountant:
      return Role.Accountant;
    case TeamMemberRole.Employee:
      return Role.Employee;
    default:
      return assertNever(editableRole);
  }
};

export const canSelectRole = ({
  hasAuthorization,
  role,
}: {
  role: TeamMemberTransitionRole;
  hasAuthorization: boolean;
}) => {
  const isDisabled = !hasAuthorization;

  return {
    disabledReason: isDisabled
      ? TeamMemberTransitionDisabledReason.PermissionTooLow
      : undefined,
    isDisabled,
    role: role,
  };
};
